import { FORM_SCHEMA_TYPES as TYPES } from "../formSchemaTypes";

const VIETNAM_SELECT_VALUES = {
  COUNTRIES_V2: "COUNTRIES_V2",
  GENDERS_V2: "GENDERS_V2",
  TRAVEL_DOCUMENT_TYPE_V2: "TRAVEL_DOCUMENT_TYPE_V2",
  PURPOSE_OF_ENTRY_V2: "PURPOSE_OF_ENTRY_V2",
  ENTRIES_OPTIONS_V2: "ENTRIES_OPTIONS_V2",
  VISA_TYPE_V2: "VISA_TYPE_V2",
  CHECKPOINTS_V2: "CHECKPOINTS_V2",
  PAYER_TYPE_V2: "PAYER_TYPE_V2",
  PAYMENT_METHODS_V2: "PAYMENT_METHODS_V2",
  SECURITY_QUESTIONS_V2: "SECURITY_QUESTIONS_V2",
};

export const vietnamSchema = {
  generalInfoSegment: {
    label: "General application information",
    type: TYPES.SEGMENT,
    initialOpen: true,
    data: {
      _id: {
        label: "ID",
      },
      isFullyFilled: {
        label: "Form fully filled",
      },
      applicantNumber: {
        label: "Applicant number",
        type: TYPES.TEXT,
      },
      siteId: {
        label: "Referral Site",
      },
      orderId: {
        label: "Order ID",
      },
      orderIdHistory: {
        label: "Order ID History",
      },
      invoiceEmail: {
        label: "Payment email",
      },
      zendeskId: {
        label: "Zendesk ID",
        type: TYPES.TEXT,
        required: false,
      },
      userLanguage: {
        label: "User form language",
      },
      userCountry: {
        label: "Users IP country",
      },
      botRuns: {
        label: "Number of bot runs",
      },
      userEmail: {
        label: "User contact email",
        type: TYPES.EMAIL,
      },
      submissionEmail: {
        label: "User submission email",
        type: TYPES.TEXT,
      },
    },
  },
  applicant_information: {
    label: "Applicant information",
    type: TYPES.SEGMENT,
    data: {
      firstName: {
        label: "Given name",
        type: TYPES.TEXT,
        required: true,
      },
      lastName: {
        label: "Surname",
        type: TYPES.TEXT,
        required: true,
      },
      dateOfBirth: {
        label: "Date of birth",
        type: TYPES.DATE,
        required: true,
      },
      nationality: {
        label: "Current nationality",
        type: TYPES.SELECT,
        required: true,
        values: VIETNAM_SELECT_VALUES.COUNTRIES_V2,
      },
      nationalityOfBirth: {
        label: "Nationality of birth",
        type: TYPES.SELECT,
        required: true,
        values: VIETNAM_SELECT_VALUES.COUNTRIES_V2,
      },
      placeOfBirth: {
        label: "Place of birth",
        type: TYPES.TEXT,
        required: true,
      },
      userEmail: {
        label: "Email",
        type: TYPES.EMAIL,
        required: true,
      },
      idCardNumber: {
        label: "ID Card Number",
        type: TYPES.TEXT,
        required: true,
      },
      gender: {
        label: "Gender",
        type: TYPES.SELECT,
        required: true,
        values: VIETNAM_SELECT_VALUES.GENDERS_V2,
      },
    },
  },
  passport_information: {
    label: "Passport information",
    type: TYPES.SEGMENT,
    data: {
      passportNumber: {
        label: "Passport number",
        type: TYPES.TEXT,
        required: true,
      },
      confirmedPassportNumber: {
        label: "Confirmed Passport number",
        type: TYPES.TEXT,
        required: true,
      },
      passportType: {
        label: "Passport type",
        type: TYPES.SELECT,
        required: true,
        values: VIETNAM_SELECT_VALUES.TRAVEL_DOCUMENT_TYPE_V2,
      },
      placeOfIssue: {
        label: "Place of issue",
        type: TYPES.TEXT,
        required: true,
      },
      passportTypeDetails: {
        label: "Passport type details",
        type: TYPES.TEXT,
        dependsOn: "passportType",
        dependantOnValues: ["Other"],
      },
      dateOfIssue: {
        label: "Date of issue",
        type: TYPES.DATE,
        required: true,
      },
      expirationDate: {
        label: "Expiration date",
        type: TYPES.DATE,
        required: true,
      },
      haveUsedOtherPassports: {
        label: "Have you ever used any other passports to enter into Vietnam?",
        type: TYPES.CHECKBOX,
      },
      usedOtherPassports: {
        label: "Other passports used to enter Vietnam",
        type: TYPES.ARRAY,
        dependsOn: "haveUsedOtherPassports",
        data: {
          firstName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "usedOtherPassports.$usedOtherPassports",
          },
          lastName: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "usedOtherPassports.$usedOtherPassports",
          },
          documentNumber: {
            label: "Document number",
            type: TYPES.TEXT,
            path: "usedOtherPassports.$usedOtherPassports",
          },
          dateOfBirth: {
            label: "Date of birth",
            type: TYPES.DATE,
            path: "usedOtherPassports.$usedOtherPassports",
          },
          nationality: {
            label: "Nationality",
            type: TYPES.SELECT,
            path: "usedOtherPassports.$usedOtherPassports",
            values: VIETNAM_SELECT_VALUES.COUNTRIES_V2,
            value: "$key",
          },
        },
      },
      haveOtherPassports: {
        label: "Do you hold any other valid passports?",
        type: TYPES.CHECKBOX,
      },
      otherPassports: {
        label: "Valid passport details",
        type: TYPES.NESTED,
        dependsOn: "haveOtherPassports",
        newTable: true,
        nested: {
          passportNumber: {
            label: "Passport number",
            type: TYPES.TEXT,
            path: "otherPassports",
          },
          confirmedPassportNumber: {
            label: "Confirm Passport number",
            type: TYPES.TEXT,
            path: "otherPassports",
          },
          passportType: {
            label: "Passport type",
            type: TYPES.SELECT,
            values: VIETNAM_SELECT_VALUES.TRAVEL_DOCUMENT_TYPE_V2,
            path: "otherPassports",
          },
          placeOfIssue: {
            label: "Place of issue",
            type: TYPES.TEXT,
            path: "otherPassports",
          },
          passportTypeDetails: {
            label: "Passport type details",
            type: TYPES.TEXT,
            dependsOn: "otherPassports.passportType",
            dependantOnValues: ["Other"],
            path: "otherPassports",
          },
          dateOfIssue: {
            label: "Date of issue",
            type: TYPES.DATE,
            path: "otherPassports",
          },
          expirationDate: {
            label: "Expiration date",
            type: TYPES.DATE,
            path: "otherPassports",
          },
        },
      },
      multipleNationalities: {
        label: "Do you have multiple nationalities?",
        type: TYPES.CHECKBOX,
      },
      multipleNationalitiesDetails: {
        label: "Specify details of other nationalities",
        type: TYPES.TEXT,
        dependsOn: "multipleNationalities",
      },
      violatedLaws: {
        label: "Have you violated any Vietnamese laws or regulations?",
        type: TYPES.CHECKBOX,
      },
      lawViolations: {
        label: "Law violation",
        type: TYPES.ARRAY,
        dependsOn: "violatedLaws",
        data: {
          actOfViolation: {
            label: "Act of violation",
            type: TYPES.TEXT,
            path: "lawViolations.$lawViolations",
          },
          dateOfViolation: {
            label: "Date of violation",
            type: TYPES.DATE,
            path: "lawViolations.$lawViolations",
          },
          formOfSanction: {
            label: "Form of sanction",
            type: TYPES.TEXT,
            path: "lawViolations.$lawViolations",
          },
          sanctionAuthority: {
            label: "Authority imposed sanction",
            type: TYPES.TEXT,
            path: "lawViolations.$lawViolations",
          },
        },
      },
    },
  },
  personal_information: {
    label: "Personal information",
    type: TYPES.SEGMENT,
    data: {
      residentialAddress: {
        label: "Permanent residential address",
        type: TYPES.TEXT,
        required: true,
      },
      contactAddress: {
        label: "Contact address",
        type: TYPES.TEXT,
        required: true,
      },
      religion: {
        label: "Religion",
        type: TYPES.TEXT,
        required: true,
      },
      occupation: {
        label: "Occupation",
        type: TYPES.TEXT,
        required: true,
      },
      companyName: {
        label: "Name of company / agency / school",
        type: TYPES.TEXT,
        required: true,
      },
      position: {
        label: "Position / course of study",
        type: TYPES.TEXT,
        required: true,
      },
      occupationAddress: {
        label: "Occupation Address",
        type: TYPES.TEXT,
        required: true,
      },
      occupationPhoneNumber: {
        label: "Occupation Phone number",
        type: TYPES.TEXT,
        required: true,
      },
      emergencyFirstName: {
        label: "Emergency contact - Given name",
        type: TYPES.TEXT,
        required: true,
      },
      emergencyLastName: {
        label: "Emergency contact - Surname",
        type: TYPES.TEXT,
        required: true,
      },
      emergencyAddress: {
        label: "Emergency contact - Address",
        type: TYPES.TEXT,
        required: true,
      },
      emergencyPhoneNumber: {
        label: "Emergency contact - Phone number",
        type: TYPES.TEXT,
        required: true,
      },
      emergencyRelationType: {
        label: "Emergency contact - Relationship to you",
        type: TYPES.TEXT,
        required: true,
      },
    },
  },
  travel_information: {
    label: "Travel information",
    type: TYPES.SEGMENT,
    data: {
      purposeOfEntry: {
        label: "Purpose of entry",
        type: TYPES.SELECT,
        values: VIETNAM_SELECT_VALUES.PURPOSE_OF_ENTRY_V2,
        required: true,
      },
      lengthOfStay: {
        label: "Intended length of stay in days",
        type: TYPES.NUMBER,
        required: true,
      },
      entryDate: {
        label: "Intended date of entry",
        type: TYPES.DATE,
        required: true,
      },
      vietnamPhoneNumber: {
        label: "Phone number in Vietnam",
        type: TYPES.TEXT,
        required: true,
      },
      vietnamAddress: {
        label: "Residential address in Vietnam",
        type: TYPES.TEXT,
        required: true,
      },
      city: {
        label: "City",
        type: TYPES.TEXT,
        required: true,
      },
      invitedByAgency: {
        label: "Are you invited by an agency or organization?",
        type: TYPES.CHECKBOX,
      },
      invitationDetails: {
        label: "Agency or organization information",
        type: TYPES.NESTED,
        dependsOn: "invitedByAgency",
        nested: {
          agencyName: {
            label: "Agency / organization name",
            type: TYPES.TEXT,
            path: "invitationDetails",
          },
          agencyAddress: {
            label: "Agency / organization address",
            type: TYPES.TEXT,
            path: "invitationDetails",
          },
          agencyPhone: {
            label: "Agency / organization phone number",
            type: TYPES.TEXT,
            path: "invitationDetails",
          },
          agencyPurpose: {
            label: "Purpose",
            type: TYPES.TEXT,
            path: "invitationDetails",
          },
        },
      },
      under14Included: {
        label:
          "Do you have under 14 years old accompanying child(ren) included in your passport?",
        type: TYPES.CHECKBOX,
      },
      children: {
        label: "Children information",
        type: TYPES.ARRAY,
        dependsOn: "under14Included",
        data: {
          firstName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "children.$children",
          },
          lastName: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "children.$children",
          },
          dateOfBirth: {
            label: "Date of birth",
            type: TYPES.DATE,
            path: "children.$children",
          },
          gender: {
            label: "Gender",
            type: TYPES.SELECT,
            values: VIETNAM_SELECT_VALUES.GENDERS_V2,
            path: "children.$children",
          },
        },
      },
      visitedLastYear: {
        label: "Have you been in Vietnam in the last year?",
        type: TYPES.CHECKBOX,
      },
      previousVisits: {
        label: "Visit to Vietnam",
        type: TYPES.ARRAY,
        dependsOn: "visitedLastYear",
        data: {
          visitFrom: {
            label: "Date from",
            type: TYPES.DATE,
            path: "previousVisits.$previousVisits",
          },
          visitTo: {
            label: "Date to",
            type: TYPES.DATE,
            path: "previousVisits.$previousVisits",
          },
          purpose: {
            label: "Purpose",
            type: TYPES.TEXT,
            path: "previousVisits.$previousVisits",
          },
        },
      },
      hasRelativesInVietnam: {
        label: "Do you have relatives whi currently reside in Vietnam?",
        type: TYPES.CHECKBOX,
      },
      relatives: {
        label: "Relative in Vietnam",
        type: TYPES.ARRAY,
        dependsOn: "hasRelativesInVietnam",
        data: {
          firstName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "relatives.$relatives",
          },
          lastName: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "relatives.$relatives",
          },
          startDate: {
            label: "Start date of residence in Vietnam",
            type: TYPES.DATE,
            path: "relatives.$relatives",
          },
          nationality: {
            label: "Nationality",
            type: TYPES.SELECT,
            values: VIETNAM_SELECT_VALUES.COUNTRIES_V2,
            path: "relatives.$relatives",
            value: "$key",
          },
          address: {
            label: "Residential address",
            type: TYPES.TEXT,
            path: "relatives.$relatives",
          },
          relationship: {
            label: "Relationship to you",
            type: TYPES.TEXT,
            path: "relatives.$relatives",
          },
        },
      },
      entryOption: {
        label: "Entry option",
        type: TYPES.SELECT,
        values: VIETNAM_SELECT_VALUES.ENTRIES_OPTIONS_V2,
        required: true,
      },
      visaType: {
        label: "Visa type",
        type: TYPES.SELECT,
        values: VIETNAM_SELECT_VALUES.VISA_TYPE_V2,
        required: true,
      },
      validityVisaFrom: {
        label: "Grant visa validity from",
        type: TYPES.DATE,
        required: true,
      },
      validityVisaTo: {
        label: "Grant visa validity to",
        type: TYPES.DATE,
        required: true,
      },
      entranceCheckpoint: {
        label: "Entrance checkpoint",
        type: TYPES.SELECT,
        values: VIETNAM_SELECT_VALUES.CHECKPOINTS_V2,
        required: true,
      },
      exitCheckpoint: {
        label: "Exit checkpoint",
        type: TYPES.SELECT,
        values: VIETNAM_SELECT_VALUES.CHECKPOINTS_V2,
        required: true,
      },
      intendedExpenses: {
        label: "Intended expenses in USD",
        type: TYPES.NUMBER,
        required: true,
      },
      payerType: {
        label: "Who will pay for your trip?",
        type: TYPES.SELECT,
        values: VIETNAM_SELECT_VALUES.PAYER_TYPE_V2,
        required: true,
      },
      paymentDetails: {
        label: "Payment details",
        type: TYPES.NESTED,
        nested: {
          coveringMethod: {
            label: "Method of covering for your trip",
            type: TYPES.SELECT,
            values: VIETNAM_SELECT_VALUES.PAYMENT_METHODS_V2,
            required: true,
            path: "paymentDetails",
          },
          agencyName: {
            label: "Agency / organization name",
            type: TYPES.TEXT,
            dependsOn: "payerType",
            dependantOnValues: ["Other organization / individual"],
            path: "paymentDetails",
          },
          agencyAddress: {
            label: "Enter full address",
            type: TYPES.TEXT,
            dependsOn: "payerType",
            dependantOnValues: ["Other organization / individual"],
            path: "paymentDetails",
          },
        },
      },
      healthInsurance: {
        label: "Do you have health insurance arranged to stay in Vietnam?",
        type: TYPES.CHECKBOX,
      },
      healthInsuranceDetails: {
        label: "Specify details of health insurance",
        type: TYPES.TEXT,
        dependsOn: "healthInsurance",
      },
    },
  },
  consent_and_declaration: {
    label: "Consent and declaration",
    type: TYPES.SEGMENT,
    data: {
      securityQuestion: {
        label: "Security question",
        type: TYPES.SELECT,
        values: VIETNAM_SELECT_VALUES.SECURITY_QUESTIONS_V2,
      },
      securityAnswer: {
        label: "Answer",
        type: TYPES.TEXT,
        required: true,
      },
      applicantSignature: {
        label: "Signature of applicant",
        type: TYPES.TEXT,
        required: true,
      },
      agreeConsent: {
        label: "Agree with Consent and Declaration",
        type: TYPES.CHECKBOX,
      },
      agreeTerms: {
        label: "Agree with Terms & Conditions",
        type: TYPES.CHECKBOX,
      },
      guardianName: {
        label: "Parent / Guardian's Name",
        type: TYPES.TEXT,
        required: false,
      },
      guardianSignature: {
        label: "Signature of parent or guardian",
        type: TYPES.TEXT,
        required: false,
      },
    },
  },
};
